import React from 'react';
import { FaCheck } from "react-icons/fa";

const CircleWithCheck = () => {
  return (
    <div className="circle-container">
      <div className="circle" style={{
        width: '42px',
        height: '42px',
        backgroundColor: '#fff', // white background
        border: `2px solid #237729`, // border with color #3c6e51
        borderRadius: '50%', // make the circle rounded
        display: 'flex', // center the icon vertically and horizontally
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <FaCheck style={{ color: '#237729' }} />
      </div>
    </div>
  );
};

export default CircleWithCheck;
